<template>
  <div>
    <el-date-picker
      v-model="dateValue"
      :type="dateType"
      :value-format = "valueFmt"
      :format="fmt"
      :editable="dateEditable"
      :placeholder="datePlaceholder" style="width: 100%">
    </el-date-picker>
  </div>
</template>
<script>
  export default{
    name: 'date-picker',
    props: ['value', 'type', 'placeholder', 'value-format', 'format', 'editable','day'],
    data(){
      return {
        dateValue: this.value || '',
        dateType:this.type||'date',
        datePlaceholder:this.placeholder || '请选择日期',
        valueFmt:this.valueFormat || 'timestamp',
        fmt:this.format || 'yyyy-MM-dd',
        dateEditable:this.editable || false,
        dateDay: '',
      }
    },
    mounted(){
        this.dateDay = this.day
    },
    watch:{
      dateValue(val){
          if(this.dateDay == 'start'){
            var date = val?new Date(val+' 00:00:00').getTime():''
            this.$emit('input',date)
          }else if(this.dateDay == "end"){
            var date = val?new Date(val+' 23:59:59').getTime():''
            this.$emit('input',date)
          }else{
            this.$emit('input',val)
          }
      },
      dateDay(val){
          if(val == 'start'||val=="end"){
              this.valueFmt = 'yyyy/MM/dd'
              this.fmt = 'yyyy-MM-dd'
          }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue